import React from "react"
import {
  TElementModuleOptions,
  TElementPrices,
  TOhterValues,
} from "../../../models/storageModel"

export function getCheckboxOptions(register: { [key: string]: any }) {
  const options: string[] = []
  if (register.sell_item) options.push("SALE")
  if (register.purchase_item) options.push("PURCHASE")
  if (!register.uid) options.push("SALE", "PURCHASE")
  return options
}

export const checkboxOptions = [
  { label: "Habilitar compra", value: "PURCHASE" },
  { label: "Habilitar venta", value: "SALE" },
]

export const labelStyle: React.CSSProperties = {
  fontSize: 11,
  color: "#8c8c8c",
  marginBottom: 2,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
}

export const valueStyle: React.CSSProperties = {
  fontSize: 14,
  color: "#262626",
  fontWeight: 500,
}

export const rowStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "flex-start",
  gap: 12,
  padding: "8px 0",
  borderBottom: "1px solid #f0f0f0",
}

export const getFormTaxes = (values: any, type: "sell" | "purchase", register: any, item: any) => {
  const arrayTaxes: Partial<TElementModuleOptions>[] = []
  const typeConfig =
    type === "sell"
      ? { subType: "SELL_TAX", activeKey: "sell_taxes_active_", searchKey: "sell_taxes_" }
      : { subType: "PURCHASE_TAX", activeKey: "purchase_taxes_active_", searchKey: "purchase_taxes_" }

  const formVals = { ...values }
  for (const key in formVals) {
    if (key.startsWith(typeConfig.searchKey) && !key.includes("active")) {
      const taxKey = formVals[key]
      if (taxKey) {
        const selectedTax = register.taxesOptions.find((el: any) => el.key === taxKey)
        if (selectedTax) {
          const idStr = key.replace(typeConfig.searchKey, "")
          const isActive = formVals[`${typeConfig.activeKey}${idStr}`]
          const taxItem: Partial<TElementModuleOptions> = {
            sub_type: typeConfig.subType,
            option_id: selectedTax.id,
            category: "NATIONAL",
            is_active: isActive !== false,
          }
          taxItem.id = Number(idStr)
          taxItem.element_id = item?.id
          arrayTaxes.push(taxItem)
        }
      }
    }
  }
  return arrayTaxes
}

export const getOtherValues = (values: any, item: any) => {
  const otherValues: Partial<TOhterValues>[] = []
  const cleanValues = (obj: any) => {
    for (const key in obj) { if (!obj[key]) delete obj[key] }
  }
  const handleOtherValues = (key: string, value: any, list: Partial<TOhterValues>[]) => {
    const id = Number(key.split("_").pop()!)
    const type = key.includes("type") ? "field_name" : "field_value"
    const idx = list.findIndex((el) => el.id === id)
    if (idx !== -1 && type === "field_value") { list[idx][type] = value }
    if (idx === -1 && type === "field_name") {
      const visible = values[`otherValues_visible_${id}`] ?? true
      list.push({ id, element_id: item?.id, field_name: value, is_visible: visible })
    }
  }
  cleanValues(values)
  for (const key in values) {
    if (!key.includes("_") || !values[key]) continue
    if (key.includes("otherValues") && !key.includes("visible")) handleOtherValues(key, values[key], otherValues)
    delete values[key]
  }
  return otherValues.filter((el) => el.field_name && el.field_value)
}

export const getPrices = (values: any, registerOptions: string[], item: any) => {
  const prices: Partial<TElementPrices>[] = []
  const basePrice: Partial<TElementPrices> = {
    element_id: item?.id || 0,
    is_default: true,
    is_active: true,
    is_visible: true,
  }
  const isSale = registerOptions.join("-").includes("SALE")
  const isPurchase = registerOptions.join("-").includes("PURCHASE") || values.register_type === "FIXED_ASSET"
  const existingSell = item?.prices?.find((p: any) => p.type === "SELL")
  const existingPurchase = item?.prices?.find((p: any) => p.type === "PURCHASE")

  if (isSale) {
    if (values.sell_price !== undefined && values.sell_price !== null) {
      prices.push({
        ...basePrice,
        id: existingSell?.id ?? -1,
        type: "SELL",
        value: Number(values.sell_price) || 0,
        description: "Precio de venta",
        is_active: true,
      })
    }
  } else if (existingSell?.id) {
    prices.push({
      ...basePrice,
      id: existingSell.id,
      type: "SELL",
      value: Number(existingSell.value) || 0,
      description: "Precio de venta",
      is_active: false,
    })
  }

  if (isPurchase) {
    if (values.purchase_price !== undefined && values.purchase_price !== null) {
      prices.push({
        ...basePrice,
        id: existingPurchase?.id ?? -1,
        type: "PURCHASE",
        value: Number(values.purchase_price) || 0,
        description: "Precio de compra",
        is_active: true,
      })
    }
  } else if (existingPurchase?.id) {
    prices.push({
      ...basePrice,
      id: existingPurchase.id,
      type: "PURCHASE",
      value: Number(existingPurchase.value) || 0,
      description: "Precio de compra",
      is_active: false,
    })
  }

  if (isSale && values.sell_discount !== undefined && values.sell_discount !== null && values.sell_discount >= 0) {
    prices.push({
      ...basePrice,
      id: item?.prices?.find((p: any) => p.type === "SELL_DISCOUNT")?.id ?? -1,
      type: "SELL_DISCOUNT",
      value: Number(values.sell_discount) || 0,
      description: "Descuento de venta",
    })
  }
  if (isPurchase && values.purchase_discount !== undefined && values.purchase_discount !== null && values.purchase_discount >= 0) {
    prices.push({
      ...basePrice,
      id: item?.prices?.find((p: any) => p.type === "PURCHASE_DISCOUNT")?.id ?? -1,
      type: "PURCHASE_DISCOUNT",
      value: Number(values.purchase_discount) || 0,
      description: "Descuento de compra",
    })
  }
  return prices
}

export const getModuleElementOptions = (values: any, register: any, item: any) => {
  const availablePresentation = register.displayOptions.find((el: any) => el.show === true)
  const availableCategory = register.categoryOptions.find((el: any) => el.show === true)
  const moduleOptions: Partial<TElementModuleOptions>[] = []
  const categoryKey = values.category || availableCategory?.key || "VRS"
  const displayKey = values.display || availablePresentation?.key || "UND"
  const idCategoryOption = register.categoryOptions.find((el: any) => el.key === categoryKey)?.id
  const idDisplayOption = register.displayOptions.find((el: any) => el.key === displayKey)?.id
  const idItemTypeOption = register.itemTypes.find((el: any) => el.key === values.register_type)?.id
  const idUmOption = register.umOptions.find((el: any) => el.key === values.measure_unit || (values.measure_unit === "UN" && el.key === "UND"))?.id

  if (idCategoryOption) {
    moduleOptions.push({
      id: item?.module_options?.find((el: any) => el.sub_type === "CATEGORY_ELEMENT")?.id ?? -1,
      element_id: item?.id,
      option_id: idCategoryOption,
      is_active: true,
      sub_type: "CATEGORY_ELEMENT",
      category: "NATIONAL",
    })
  }
  if (idDisplayOption) {
    moduleOptions.push({
      id: item?.module_options?.find((el: any) => el.sub_type === "DISPLAY_ELEMENT")?.id ?? -1,
      element_id: item?.id,
      option_id: idDisplayOption,
      is_active: true,
      sub_type: "DISPLAY_ELEMENT",
      category: "NATIONAL",
    })
  }
  if (idItemTypeOption) {
    moduleOptions.push({
      id: item?.module_options?.find((el: any) => el.sub_type === "TYPE_ELEMENT")?.id ?? -1,
      element_id: item?.id,
      option_id: idItemTypeOption,
      is_active: true,
      sub_type: "TYPE_ELEMENT",
      category: "NATIONAL",
    })
  }
  if (idUmOption) {
    moduleOptions.push({
      id: item?.module_options?.find((el: any) => el.sub_type === "UM_ELEMENT")?.id ?? -1,
      element_id: item?.id,
      option_id: idUmOption,
      is_active: true,
      sub_type: "UM_ELEMENT",
      category: "NATIONAL",
    })
  }
  return moduleOptions
}

export const toDataForm = (data: any, register: any) => {
  const availablePresentation = register.displayOptions.find((el: any) => el.show === true)
  const availableCategory = register.categoryOptions.find((el: any) => el.show === true)
  const sellDiscountPrice = data?.prices?.find((p: any) => p.type === "SELL_DISCOUNT" || p.type === "DISCOUNT")
  const purchaseDiscountPrice = data?.prices?.find((p: any) => p.type === "PURCHASE_DISCOUNT")
  let copy: any = {
    measure_unit: "UN",
    display: availablePresentation?.key || "UND",
    quantity: 0,
    min_quantity: data?.min_quantity ?? 0,
    is_traceable: data?.is_traceable !== undefined ? Boolean(data.is_traceable) : (data?.register_type === "FIXED_ASSET"),
    sell_discount: data?.sell_discount ?? sellDiscountPrice?.value ?? 0,
    purchase_discount: data?.purchase_discount ?? purchaseDiscountPrice?.value ?? 0,
    category: availableCategory?.key || "VRS",
    image: data?.image || "",
    image_mini: data?.image_mini || "",
    images: data?.images || (data?.image ? [{
      file_name: data.name || "Imagen principal",
      file_url: data.image,
      storage_path: "",
      is_primary: true,
      display_order: 0
    }] : [])
  }
  if (data?.uid) {
    copy = { ...copy, ...data }
    const sellTax = data.module_options?.filter((el: any) => el.sub_type === "SELL_TAX") || []
    const purchaseTax = data.module_options?.filter((el: any) => el.sub_type === "PURCHASE_TAX") || []
    for (const el of sellTax) {
      copy[`sell_taxes_${el.id}`] = register.taxesOptions.find((tax: any) => tax.id === el.option_id)?.key
      copy[`sell_taxes_active_${el.id}`] = el.is_active
    }
    for (const el of purchaseTax) {
      copy[`purchase_taxes_${el.id}`] = register.taxesOptions.find((tax: any) => tax.id === el.option_id)?.key
      copy[`purchase_taxes_active_${el.id}`] = el.is_active
    }
    for (const el of (data.other_values || [])) {
      copy[`otherValues_type_${el.id}`] = el.field_name
      copy[`otherValues_value_${el.id}`] = el.field_value
      copy[`otherValues_visible_${el.id}`] = el.is_visible
    }
  }
  copy.registerOptions = getCheckboxOptions(data || {})
  return copy
}
